import {  NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import {  HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutgaurdGuard } from './gaurd/layoutgaurd.guard';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { PasswordModule } from 'primeng/password';
import { ImageModule } from 'primeng/image';
import { ReactiveFormsModule } from '@angular/forms';
import { MainLayoutModule } from './views/main-layout/main-layout.module';
import { AppHttpIntercepter } from './httpinterceptor/httpinterceptor';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { LoginComponent } from './login/login.component';
import { ResetpageComponent } from './resetpage/resetpage.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { NgIdleModule } from '@ng-idle/core';
import { ChanagepasswordwithOTPComponent } from './chanagepasswordwith-otp/chanagepasswordwithOTP.component'; 
@NgModule({
  declarations: [
    AppComponent, PagenotfoundComponent,  LoginComponent, ResetpageComponent, ChangepasswordComponent, ChanagepasswordwithOTPComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule, 
    CardModule,ReactiveFormsModule,
    AppRoutingModule,MainLayoutModule,
    HttpClientModule,InputTextModule,ButtonModule ,PasswordModule,ImageModule,NgIdleModule.forRoot(),
   NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' })],
  
  bootstrap: [AppComponent],
  providers:[LayoutgaurdGuard,{ provide: HTTP_INTERCEPTORS, useClass: AppHttpIntercepter, multi: true }
  ]
})
export class AppModule { }
